"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentButtons = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var react_redux_1 = require("react-redux");
var actions_1 = require("../../store/cart/actions");
var Spinner_1 = __importDefault(require("react-activity/dist/Spinner"));
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var PaymentButtons = function (props) {
    var history = (0, react_router_dom_1.useHistory)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var restaurantId = (0, react_router_1.useParams)().restaurant;
    var searchParams = new URLSearchParams(location.search);
    var type = searchParams.get('type') || '';
    var stripe = (0, react_stripe_js_1.useStripe)();
    var _a = (0, react_1.useState)(null), paymentRequest = _a[0], setPaymentRequest = _a[1];
    var _b = (0, react_1.useState)(false), processing = _b[0], setProcessing = _b[1];
    var _c = (0, react_redux_1.useSelector)(function (state) { return ({
        items: state.cart.items,
        chain: state.app.chain,
        loading: state.payment.loading,
    }); }), loading = _c.loading, chain = _c.chain;
    var total = props.total;
    var storeName = (chain === null || chain === void 0 ? void 0 : chain.name) || "";
    var currency = ((chain === null || chain === void 0 ? void 0 : chain.currency.code) || "").toLowerCase();
    var country = (chain === null || chain === void 0 ? void 0 : chain.country.iso2) || currency;
    (0, react_1.useEffect)(function () {
        if (stripe) {
            var amount = Number((Number(total.toFixed(2)) * 100).toFixed(0));
            var pr_1 = stripe.paymentRequest({
                country: country,
                currency: currency,
                total: {
                    label: storeName,
                    amount: amount,
                },
                requestPayerName: true,
                requestPayerEmail: true,
            });
            pr_1.canMakePayment().then(function (result) {
                if (result) {
                    setPaymentRequest(pr_1);
                }
            }).catch(function (err) {
                console.log('canMakePayment err', err);
            });
        }
    }, [stripe]);
    if (stripe && paymentRequest) {
        paymentRequest.on('paymentmethod', function (ev) { return __awaiter(void 0, void 0, void 0, function () {
            var piData, key, _a, paymentIntent, confirmError, prevParams, newParams, URLParams, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setProcessing(true);
                        return [4, props.createPaymentIntentRequest()];
                    case 1:
                        piData = _b.sent();
                        if (!piData.client_secret) {
                            ev.complete('fail');
                            setProcessing(false);
                            console.log('fail');
                            return [2];
                        }
                        key = piData.key;
                        return [4, stripe.confirmCardPayment(piData.client_secret, { payment_method: ev.paymentMethod.id }, { handleActions: false })];
                    case 2:
                        _a = _b.sent(), paymentIntent = _a.paymentIntent, confirmError = _a.error;
                        if (!confirmError) return [3, 3];
                        ev.complete('fail');
                        setProcessing(false);
                        console.log(confirmError);
                        return [3, 6];
                    case 3:
                        prevParams = Object.fromEntries(searchParams);
                        newParams = __assign(__assign({}, prevParams), { type: type, key: key });
                        URLParams = new URLSearchParams(newParams);
                        ev.complete('success');
                        setProcessing(false);
                        if (!((paymentIntent === null || paymentIntent === void 0 ? void 0 : paymentIntent.status) === "requires_action")) return [3, 5];
                        setProcessing(true);
                        return [4, stripe.confirmCardPayment(piData.client_secret)];
                    case 4:
                        error = (_b.sent()).error;
                        if (error) {
                            setProcessing(false);
                        }
                        else {
                            dispatch((0, actions_1.cartClear)());
                            setProcessing(false);
                            history.push({ pathname: "/store/".concat(restaurantId, "/confirm"), search: URLParams.toString() });
                        }
                        return [3, 6];
                    case 5:
                        dispatch((0, actions_1.cartClear)());
                        setProcessing(false);
                        history.push({ pathname: "/store/".concat(restaurantId, "/confirm"), search: URLParams.toString() });
                        _b.label = 6;
                    case 6: return [2];
                }
            });
        }); });
        if (processing || loading) {
            return (0, jsx_runtime_1.jsx)("div", __assign({ style: { display: 'flex', justifyContent: 'center' } }, { children: (0, jsx_runtime_1.jsx)(Spinner_1.default, {}) }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(react_stripe_js_1.PaymentRequestButtonElement, { options: { paymentRequest: paymentRequest }, className: "checkout-total-button" });
        }
    }
    return null;
};
exports.PaymentButtons = PaymentButtons;
